module.exports = __webpack_public_path__ + "assets/9a25b4e7d7466d9aac4ce16b9acd28ff.mp3";